export default "__VITE_ASSET__CNeFbUm7__"